// extracted by mini-css-extract-plugin
export default {"bottomContainer":"notification_bottomContainer__QQ3Yu","background":"notification_background__L100x"};